import React from "react"
import { Link } from "gatsby"
import Layout from "@/components/Layout"
import CompletionBar from "@/components/CompletionBar"
import { Card, Button, ButtonToolbar, Modal, Container, Row, Col, Form } from "react-bootstrap";

import NavBar from "@/components/NavBar"
import RadioLikertScale from "@/components/RadioLikertScale"
import "./styles.css"

export const frontmatter = {
  title: 'Assessing Your Study Habits',
  id: 'b95824a3-8f76-4023-a847-7cc045d8990a',
  figure: '1.25',
};

var questions = [
  "",
  "Instead of cramming the night before an exam, I spread out my learning into shorter sessions over a longer period of time.",
  "To prepare for an exam, I self-test by predicting questions that will appear on the exam and then writing out the answers.",
  "While listening to a lecture, I take detailed notes that I review later as I am studying for an exam.",
  "I use a paper or app-based planner to reserve time for my daily activities, including work and study time.",
  "I break down large, intimidating projects into smaller tasks.",
  "I reward myself for achieving key milestones or completing an assignment.",
  "I turn off my smartphone and any other distractors (radio, television, social media) while I am reading and studying.",
  "I focus on one task at a time and avoid multitasking.",
  "I spend two to three hours studying for each hour I spend in a particular class.",
  "I attend every class session of every course for which I am registered."
]

class InteractiveStudyHabits extends React.PureComponent {

  arr = new Array(11)
  initalState = {
    ...frontmatter,
    panel: 1,
    showFeedback: false,
    selected: this.arr,
    showNext: true,
    showPrev: false,
    showModal: false,
    completed: false
  };

  constructor(props) {
    super(props);
    this.state = JSON.parse(JSON.stringify(this.initalState));

    this.reset = this.reset.bind(this)
    this.increment = this.increment.bind(this)
    this.decrement = this.decrement.bind(this)
    this.generatePanel = this.generatePanel.bind(this)
    this.curPanel = this.curPanel.bind(this)

    this.setShowNext = this.setShowNext.bind(this)
    this.setShowPrev = this.setShowPrev.bind(this)
    this.radioClick = this.radioClick.bind(this)

    this.generateQuestionBar = this.generateQuestionBar.bind(this)
    this.generateAlways = this.generateAlways.bind(this)
    this.generateSometimes = this.generateSometimes.bind(this)
    this.generateRarely = this.generateRarely.bind(this)
    this.completionMessage = this.completionMessage.bind(this)

    this.handleVideoCompleted = this.handleVideoCompleted.bind(this);
  }

  reset() {
    this.setState(JSON.parse(JSON.stringify(this.initalState)));
  }

  handleVideoCompleted() {
    this.setShowNext(true)
  }

  render() {
    return (
      <div>
        <div aria-live="polite">
          {this.generatePanel(this.state.panel)}
        </div>
        <NavBar
          onClickNext={this.increment}
          onClickPrev={this.decrement}
          onClickReset={this.reset}
          showPrev={this.state.showPrev}
          showNext={this.state.showNext}
          source=""
        />
        <CompletionBar completed={this.state.completed} />
      </div>
    );
  }

  increment() {
    if (this.state.panel < 16)
      this.setState({ panel: this.state.panel + 1 })
  }
  decrement() {
    if (this.state.panel > 1)
      this.setState({ panel: this.state.panel - 1 })
  }

  generateQuestionBar() {
    if (this.state.selected[this.curPanel()] === null) {
      this.setShowNext(false);
    }
    else {
      this.setShowNext(true);
    }
    return (
      <div >
        <legend className="sr-only">{"Select 1 for 'Always or almost always'. Select 2 for 'Sometimes'. Select 3 for 'Rarely'. Select 4 for 'Never'."}</legend>
        <RadioLikertScale
          style={{ margin: '0px !important' }}
          value={this.state.selected[this.curPanel()] - 1}
          onChange={this.radioClick}
          intervals={4}
        />
        <Container aria-hidden="true" style={{ marginBottom: "20px" }}>
          <Row>
            <Col>Never</Col>
            <Col>Rarely</Col>
            <Col>Sometimes</Col>
            <Col>Always or almost always</Col>
          </Row>
        </Container>
      </div>
    )
  }
  setShowNext(val) {
    if (val)
      this.setState({ showNext: true })
    else
      this.setState({ showNext: false })
  }

  setShowPrev(val) {
    if (val)
      this.setState({ showPrev: true })
    else
      this.setState({ showPrev: false })
  }

  curPanel() {
    return this.state.panel - 1
  }

  radioClick(val) {
    var temp = this.state.selected.slice();
    temp[this.curPanel()] = val + 1
    this.setState({ selected: temp, showNext: true })

  }

  generateAlways() {
    return (
      <div>
        <p>Examine the pattern of your answers. You chose “Always or almost always” in response
          to the statements listed below. Good job! These study habits will serve you well in all
          your courses.
          <br />
        </p>
        <ul style={{ textAlign: "left" }}>
          {this.state.selected.map((value, index) => {
            if (value === 4) {
              return <li key={index}> {questions[index]} </li>
            }
          })}
        </ul>
      </div>
    )
  }

  generateSometimes() {
    return (
      <div>
        <p>You chose “Sometimes” in response to the statements listed below. Not too shabby! You’ve
          built a strong foundation for studying, but you might want to improve some of your study
          habits.
          <br />
        </p>

        <ul style={{ textAlign: "left" }}>
          {this.state.selected.map((value, index) => {
            if (value === 3) {
              return <li key={index}> {questions[index]} </li>
            }
          })}
        </ul>
      </div>
    )
  }


  generateRarely() {
    return (
      <div>
        <p>You chose “Rarely” or “Never” in response to the statements listed below. These are the weak
          spots in your study habits. Consider ways to improve on them. For example, if you noted that you
          often miss class, look carefully at your schedule. Perhaps you should plan to take courses earlier
          in the day, in the evening, or online so that you miss fewer sessions.
          <br /><br />
          Carefully inspect these study habits and pick one or two that you can realistically try to improve on
          this term.
          <br />
        </p>

        <ul style={{ textAlign: "left" }}>
          {this.state.selected.map((value, index) => {
            if (value === 2 || value === 1) {
              return <li key={index}> {questions[index]} </li>
            }
          })}
        </ul>
      </div>
    )
  }

  completionMessage() {
    console.log("completionMessage", "ippip-" + window.location.href.split("/").filter(b => !b.startsWith("index.html") && b.length >= 3).pop())
    window.parent.postMessage(JSON.stringify({
      key: "ippip-" + window.location.href.split("/").filter(b => !b.startsWith("index.html") && b.length >= 3).pop(),
      message: {
        type: 'step_completed',
        payload: {
          step: 0
        }
      }
    }), '*')
    window.parent.postMessage({
      id: this.state.id,
      action: 'completed',
      eventTime: new Date().toISOString(),
      type: 'activitysubmission',
      url: window.location.href,
    }, '*');
    this.state.completed = true;
  }

  generatePanel(panel) {
    switch (panel) {
      case 1:
        this.setShowPrev(false);
        this.setShowNext(true);
        return (
          <div>
            <p>As a student of psychology, you will learn about many aspects of learning and memory that you can apply to
              your own life and study habits. For now, let’s assess your current habits.
              <br /><br />
              In response to the following 10 statements, select the answer that most closely reflects how you study.</p>
          </div>
        )
      case 2:
        this.setShowPrev(true);
        return (
          <div>
            <p className="likert-study-habit-question">1. {questions[this.curPanel()]}</p>
            {this.generateQuestionBar()}
          </div>
        )
      case 3:
        return (
          <div>
            <p className="likert-study-habit-question">2. {questions[this.curPanel()]}</p>
            {this.generateQuestionBar()}
          </div>
        )
      case 4:
        return (
          <div>
            <p className="likert-study-habit-question">3. {questions[this.curPanel()]}</p>
            {this.generateQuestionBar()}
          </div>
        )
      case 5:
        return (
          <div>
            <p className="likert-study-habit-question">4. {questions[this.curPanel()]}</p>
            {this.generateQuestionBar()}
          </div>
        )
      case 6:
        return (
          <div>
            <p className="likert-study-habit-question">5. {questions[this.curPanel()]}</p>
            {this.generateQuestionBar()}
          </div>
        )
      case 7:
        return (
          <div>
            <p className="likert-study-habit-question">6. {questions[this.curPanel()]}</p>
            {this.generateQuestionBar()}
          </div>
        )
      case 8:
        return (
          <div>
            <p className="likert-study-habit-question"> 7. {questions[this.curPanel()]}</p>
            {this.generateQuestionBar()}
          </div>
        )
      case 9:
        return (
          <div>
            <p className="likert-study-habit-question"> 8. {questions[this.curPanel()]}</p>
            {this.generateQuestionBar()}
          </div>
        )
      case 10:
        return (
          <div>
            <p className="likert-study-habit-question">9. {questions[this.curPanel()]}</p>
            {this.generateQuestionBar()}
          </div>
        )
      case 11:
        return (
          <div>
            <p className="likert-study-habit-question">10. {questions[this.curPanel()]}</p>
            {this.generateQuestionBar()}
          </div>
        )
      case 12:
        if (!this.state.selected.includes(3) && !this.state.selected.includes(2) && !this.state.selected.includes(1)) {
          this.completionMessage();
          this.setShowNext(false);
          return (<div> {this.generateAlways()} </div>);
        }
        else if (!this.state.selected.includes(4) && !this.state.selected.includes(2) && !this.state.selected.includes(1)) {
          this.completionMessage();
          this.setShowNext(false);
          return (<div> {this.generateSometimes()}</div>);
        }
        else if (!this.state.selected.includes(4) && !this.state.selected.includes(3)) {
          this.completionMessage();
          this.setShowNext(false);
          return (<div> {this.generateRarely()}</div>);
        }
        else if (!this.state.selected.includes(4) && this.state.selected.includes(3)) {
          this.setShowNext(true);
          return (<div> {this.generateSometimes()}</div>);
        }
        else {
          this.setShowNext(true);
          return (<div> {this.generateAlways()}</div>);
        }

      case 13:
        if ((!this.state.selected.includes(4) && this.state.selected.includes(3)) || (this.state.selected.includes(4) && !this.state.selected.includes(3))) {
          this.setShowNext(false);
          this.completionMessage();
          return (<div> {this.generateRarely()}</div>);
        }
        else {
          this.setShowNext(true);
          return (<div> {this.generateSometimes()}</div>);
        }
      case 14:
        this.setShowNext(false);
        this.completionMessage();
        return (<div> {this.generateRarely()}</div>);
    }
  }
}


const PageStudyHabits = () => (
  <Layout {...frontmatter}>
    <InteractiveStudyHabits />
  </Layout>
)

export default PageStudyHabits
